import React from "react";
import Modal from "../index";
import {FlexContainer, Img, Text} from "../../../design";
import success from "../../../assets/imgs/success.svg";

type Props = {
  isOpen: boolean,
  partnerConnection: Boolean,
  successMsg: String,
  processing: Boolean,
  accountId: String,
  paymentId: String,
}
const SuccessModal = (props : Props) => {
  return (
    <Modal isOpen={props.isOpen}>
        <FlexContainer
            height="400px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            box-shadow="0 0 20px 0 rgba(0, 0, 0, 0.1)"
            backdropFilter='none'
            borderRadius='4px'
            backgroundColor="#f2f5f8"
            textAlign='center'
            alignContent='none'
        >
            <Img width='108px' height='108px' paddingBottom='25px' src={success} />
            <Text
                fontSize="20px"
                fontWeight='600'
            >
                {props.successMsg ? props.successMsg : (props.partnerConnection ? 'Partner Connection Completed' : (props.processing ? 'Payment placed successfully in the process': 'Transaction Complete'))}
            </Text>
            <Text fontSize="16px" textAlign="center" paddingX="14px">
                {(props?.accountId === 'account-c0adbb4137dc4d6c9a9df98cb29bf401' && props?.paymentId === 'paymentpagelink-b4b57686aabf4f5fa8d7ae02d866741b')
                ?  (<>
                Please look for an email from{" "}
                <a href="mailto:support@swirepay.com" color="blue.500">
                  support@swirepay.com
                </a>{" "}
                for payment confirmation and tickets.
              </>)
                : ('You will be redirected automatically.')}
            </Text>
        </FlexContainer>
    </Modal>
  )
};

export default SuccessModal;
